import _assign from "object-assign";
import color from './color';
import typography from './typography';
var base = {
  body: _assign({}, typography.sansSerifBody1),
  a: {
    color: color.grey900,
    textDecoration: 'underline',
    '&:hover': {
      color: color.blue500
    },
    '&:active': {
      color: color.blue500
    },
    '&:visited': {
      color: 'currentColor'
    },
    '.jpmuitk-dark &': {
      color: color.white,
      textDecoration: 'underline',
      '&:hover': {
        color: color.blue200
      },
      '&:active': {
        color: color.blue200
      },
      '&:visited': {
        color: 'currentColor'
      }
    }
  },
  accessibleText: {
    display: 'block',
    position: 'absolute',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    top: 0,
    left: 0,
    opacity: 0
  },
  iconFont: {
    fontFamily: '"jpmuitk-icons" !important',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontVariant: 'normal',
    textTransform: 'none',
    speak: 'none'
  },
  ':focus': {
    outline: 'none'
  }
};
export default base;